module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"placeholder":"Nach Land suchen"},"en":{"placeholder":"Search for a land"}}')
  delete Component.options._Ctor
}
